/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_od_dilution_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dilution factor`)
};

const es_od_dilution_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Factor de dilución`)
};

const de_od_dilution_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verdünnungsfaktor`)
};

const nl_od_dilution_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verdunningsfactor`)
};

const fr_od_dilution_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facteur de dilution`)
};

const it_od_dilution_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fattore di diluizione`)
};

const pt_br2_od_dilution_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fator de diluição`)
};

const pt_od_dilution_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fator de diluição`)
};

const ja_od_dilution_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`希釈倍率`)
};

const zh_od_dilution_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`稀释倍数`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const od_dilution_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.od_dilution_label(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("od_dilution_label", locale)
	if (locale === "en") return en_od_dilution_label(inputs)
	if (locale === "es") return es_od_dilution_label(inputs)
	if (locale === "de") return de_od_dilution_label(inputs)
	if (locale === "nl") return nl_od_dilution_label(inputs)
	if (locale === "fr") return fr_od_dilution_label(inputs)
	if (locale === "it") return it_od_dilution_label(inputs)
	if (locale === "pt-BR") return pt_br2_od_dilution_label(inputs)
	if (locale === "pt") return pt_od_dilution_label(inputs)
	if (locale === "ja") return ja_od_dilution_label(inputs)
	return zh_od_dilution_label(inputs)
};